import { SPH4U } from "../../data/OSSD/Grade12/SPH4U";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function SPH4UPage() {
    return (
        <div>
            <GradeCourseTemplate data={SPH4U} />
        </div>
    )
}